
export class ProfileInfo {
    public activeProfiles: string[];
    public ribbonEnv: string;
    public inProduction: boolean;
    public swaggerEnabled: boolean;
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/models/profile-info.model.ts